import React, { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button, Menu, MenuItem, MenuList } from "@mui/material";
import { IFolder } from "store/types";

import { useFolderHook } from "../Hooks/use-folder-hook";

const panelMenuPaperSx = {
  borderRadius: "8px",
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.12)",
  minWidth: 200,
  padding: "6px 0"
};

const panelMenuItemSx = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  fontSize: "15px",
  color: "#20293C",
  minHeight: 40,
  "&:hover": { backgroundColor: "#ECF1F8" }
};

interface Props {
  currentFolder: IFolder | null;
  refetchHandler: () => Promise<void>;
}

export const AddNewMenu: React.FC<Props> = ({ currentFolder, refetchHandler }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const onMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const onMenuClose = () => {
    setAnchorEl(null);
  };

  const { onCreateNewFolder, onFileUpload } = useFolderHook({
    folder: {
      id: currentFolder?.id || -1,
      title: currentFolder?.title || "",
      parent_id: currentFolder?.parent_id || null
    },
    refetchHandler
  });

  const options = [
    {
      title: "New Folder",
      icon: <CreateNewFolderOutlinedIcon sx={{ fill: "#5d7782" }} />,
      onClick: () => {
        onMenuClose();
        onCreateNewFolder?.();
      },
      disabled: false
    },
    {
      title: "Upload File",
      icon: <FileUploadOutlinedIcon sx={{ fill: "#5d7782" }} />,
      onClick: () => {
        onMenuClose();
        onFileUpload?.();
      },
      disabled: false
    }
  ];

  return (
    <>
      <Button
        onClick={onMenuOpen}
        variant="contained"
        startIcon={<AddIcon />}
        sx={{
          bgcolor: "#10212E",
          color: "#fff",
          fontSize: "16px",
          fontWeight: 400
        }}
      >
        Add New
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{ paper: { sx: panelMenuPaperSx } }}
        MenuListProps={{ sx: { padding: 0 } }}
      >
        <MenuList disablePadding>
          {options.map((option) => (
            <MenuItem key={option.title} onClick={option.onClick} disabled={option.disabled} sx={panelMenuItemSx}>
              {option.icon}
              {option.title}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </>
  );
};
